import * as __WEBPACK_EXTERNAL_MODULE__assert_index_js_255db76f__ from "../assert/index.js";
const DEFAULT_UNITS = 'px';
function setCssVar(cssVar, value) {
    document.documentElement.style.setProperty(cssVar, value);
}
function getCssVar(cssVar) {
    return getComputedStyle(document.documentElement).getPropertyValue(cssVar);
}
function setCssVarNumber(cssVar, value, units = DEFAULT_UNITS) {
    (0, __WEBPACK_EXTERNAL_MODULE__assert_index_js_255db76f__.assert)('number' == typeof value, 'Value must be a number');
    setCssVar(cssVar, `${value}${units}`);
}
function getCssVarNumber(cssVar) {
    return Number.parseInt(getCssVar(cssVar), 10);
}
const cssVar_rslib_entry_cssVar = {
    get: getCssVar,
    set: setCssVar,
    getNumber: getCssVarNumber,
    setNumber: setCssVarNumber
};
export { cssVar_rslib_entry_cssVar as cssVar };
